<div class="sl-modal">

  <!-- Header -->
  <div class="sl-modal-header">
    <div class="sl-modal-icon">
      <i class="fa-solid fa-language"></i>
    </div>
    <div class="sl-modal-titles">
      <h2 class="sl-modal-title" translate>Langue d'interface incompatible</h2>
      <p class="sl-modal-subtitle" translate>Tu ne peux pas apprendre une langue depuis la même langue d'interface</p>
    </div>
    <button class="sl-close-btn" type="button" (click)="close()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="sl-modal-body">

    <div class="sl-lang-card">
      <img src="assets/images/flags/{{langTgt.flag}}" [alt]="langTgt.name" class="sl-flag"/>
      <div>
        <div class="sl-lang-label" translate>Pour apprendre</div>
        <div class="sl-lang-name">{{langTgt.name}}</div>
      </div>
    </div>

    <form [formGroup]="form" (submit)="onSubmit()">
      <div class="sl-form-group">
        <label class="sl-label" for="idLangSrc" translate>Langue d'interface</label>
        <div class="sl-select-wrapper">
          <select id="idLangSrc" class="sl-select" formControlName="idLangSrc">
            <option *ngFor="let lang of languages; trackBy: trackById" [value]="lang.id">{{lang.name}}</option>
          </select>
          <i class="fa-solid fa-caret-down sl-select-caret"></i>
        </div>
      </div>

      <button type="submit" class="sl-btn-primary" [disabled]="form.invalid || loading" translate>
        Enregistrer et continuer
      </button>
      <button type="button" class="sl-btn-ghost" (click)="close()" translate>
        Ignorer
      </button>
    </form>

  </div>
</div>
